/**
 * Search Providers — registration entry point.
 *
 * Providers are registered here in display order (controls section order).
 * To add a new provider (e.g. sermons, materials):
 *   1. Create the provider file in this folder
 *   2. Import it below and call registry.register(myProvider)
 *   3. useSearchData picks it up automatically via registry.getAll()
 *   4. Add a buildSections entry in GlobalSearchModal for display
 */

import { registry } from "../lib/ProviderRegistry";
import peopleProvider     from "./peopleProvider";
import familiesProvider   from "./familiesProvider";
import churchesProvider   from "./churchesProvider";
import visitsProvider     from "./visitsProvider";
import prayersProvider    from "./prayersProvider";
import notesProvider      from "./notesProvider";
import eventsProvider     from "./eventsProvider";
import preachingProvider  from "./preachingProvider";
import materialsProvider  from "./materialsProvider";
import baptismsProvider   from "./baptismsProvider";

registry
  .register(peopleProvider)
  .register(familiesProvider)
  .register(churchesProvider)
  .register(visitsProvider)
  .register(prayersProvider)
  .register(notesProvider)
  .register(eventsProvider)
  .register(preachingProvider)
  .register(materialsProvider)
  .register(baptismsProvider);

export { peopleProvider, familiesProvider, churchesProvider, visitsProvider, prayersProvider, notesProvider, eventsProvider, preachingProvider, materialsProvider, baptismsProvider };
export { registry };
